import { RatingType, ResponseProductType } from '@/data/types/Product';

export const getProductRatings = (product: ResponseProductType): RatingType => ({
	rating: product['x_ratings.rating'] ? Number(product['x_ratings.rating']) : 0,
	reviews: product['x_ratings.total_reviews'] ? Number(product['x_ratings.total_reviews']) : 0,
	recommendation: product['x_ratings.total_recommendation']
		? Number(product['x_ratings.total_recommendation'])
		: 0,
});
